/* src/app/components/doc-viewer-new/dialogs/manual-upload-dialog/manual-upload-dialog.component.scss */
[dialog-body] {
  color: var(--text-color);
}
:host-context(.dark-theme) [dialog-body] {
  color: var(--text-color);
}
.custom-file-input {
  background-color: #E4E4E4;
  position: relative;
  display: inline-block;
  border-radius: 5px;
}
input[type=file] {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  z-index: 2;
}
label {
  background: #3949AB;
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  z-index: 1;
}
span {
  margin-left: 10px;
}
:host-context(.dark-theme) .custom-file-input {
  background: rgba(69, 69, 69, 0.95);
}
:host-context(.dark-theme) label {
  background-color: #191919;
  color: #FFC107;
}
/*# sourceMappingURL=manual-upload-dialog.component.css.map */
